'use strict';

var log = require('../log/Log').channel('KayleeCache');

var cache = {};

// This is a simple cache implementation for FirebaseObject, FirebaseArray,
// and FirebaseIndirectArray instances.
// 
// Objects are placed into the cache with the put function.
//
// Objects are retrieved from the cache with the get function. It returns null
// if there is no value for the specified key.
//
// Objects placed into the cache must have an $onDestroy method that is used to
// register a callback for when the object is destroyed. There is no reference
// counting in the cache. Objects placed in the cache remain there until the
// object itself is destroyed, then the object is removed from the cache via
// an $onDestroy callback.
//
// For FirebaseObject, FirebaseArray, and FirebaseIndirectArray instances, the
// onCancelled functionality of the Firebase subscription is used to
// automatically destroy the object (and thus remove it from the cache) when
// access to the object is revoked.

var KayleeCache = {
    clear: clear,
    get: get,
    getCache: getCache,
    put: put,
};

function clear() {
    log.debug('clearing cache');

    for (var key in cache) {
        if (!cache.hasOwnProperty(key)) continue;
        cache[key].$destroy();
    }

    cache = {};
}

function get(key) {
    if (!cache.hasOwnProperty(key)) return null;
    //log.debug('got ' + key);
    return cache[key];
}

function getCache() {
    return cache;
}

function put(key, obj) {
    if (cache.hasOwnProperty(key)) {
        log.error('cache already has ' + key);
    }

    obj.$onDestroy(function() {
        //log.debug('onDestroy: removing key from cache: ' + key);
        delete cache[key];
    });
    log.debug('put ' + key);
    obj.$cacheKey = key;
    cache[key] = obj;
}

module.exports = KayleeCache;